import React, { Component } from 'react'
import './index.scss'
import { Tabs } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

export class index extends Component {
  static defaultProps = {
    titleIshow: true
  }

  state = {
    items: [
      {
        name: '工业控制传感器',
        image: require('../../../image/icon工业控制-蓝.png'),
        selectimage: require('../../../image/icon工业控制-圆.png'),
        children: [
          { title: '防爆型压力变送器', text: '选用进口传感器压力敏感元件，采用计算机激光调阻进行温度补偿。一体化的接线盒设计有专用接线端子及指针或数字显示，安装、校验、维修方便等特点。', image: require('../../../image/防爆型.png'), to: '/product/hardware/10.html' },
          { title: '通用型压力变送器', text: '选用进口传感器压力敏感元件，采用计算机激光调阻进行温度补偿。一体化的接线盒有专用接线端子以及指针或数字显示，安装、校验、维修方便等特点。', image: require('../../../image/通用型.png'), to: '/product/hardware/9.html' }
        ]
      },
      {
        name: '环境监测传感器',
        image: require('../../../image/icon环境监测-蓝.png'),
        selectimage: require('../../../image/icon环境监测-圆.png'),
        children: [
          { title: '高温温湿度变送器', text: '高温温湿度变送器采用瑞士电容式湿度传感器，生产时已经过精细的标定，标定数据存储在内部存储器中，安全可靠。', image: require('../../../image/t1.png'), to: '/product/hardware/6.html' },
          { title: '风道式温湿度传感器', text: '广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、洁净车间等需测量空气温度的领域。', image: require('../../../image/t2.png'), to: '/product/hardware/8.html' },
          { title: '数显温湿度变送器', text: '适用于环境设备配套，仪器设备集成，大量的一般性环境测验，测量精度、线性度、重复性、互转性、一致性等方面均表现出色。', image: require('../../../image/t3.png'), to: '/product/hardware/5.html' }
        ]
      },
      {
        name: '仪表及隔离模块',
        image: require('../../../image/icon仪表盘-蓝.png'),
        selectimage: require('../../../image/icon仪表盘-圆.png'),
        children: [
          { title: '低温储罐运行监测一体机', text: '高温温湿度变送器采用瑞士电容式湿度传感器，生产时已经过精细的标定，标定数据存储在内部存储器中，安全可靠。', image: require('../../../image/低温储蓄罐.png'), to: '/product/hardware/4.html' },
          { title: '气体运行监测报警器', text: '广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、洁净车间等需测量空气温度的领域。', image: require('../../../image/气体运行监测报警器.png'), to: '/product/hardware/2.html' },
          { title: '空气系统运行监测箱', text: '广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、洁净车间等需测量空气温度的领域。', image: require('../../../image/空气系统运行监测箱.png'), to: '/product/hardware/1.html' },
          { title: '真空系统运行监测箱', text: '广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、洁净车间等需测量空气温度的领域。', image: require('../../../image/真空系统运行监测箱.png'), to: '/product/hardware/3.html' },
          { title: '气体汇流排运行监测箱', text: '广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、洁净车间等需测量空气温度的领域。', image: require('../../../image/气体汇流排运行监测箱.png'), to: '/product/hardware/11.html' },
          { title: '低温储罐运行监测仪', text: '适用于环境设备配套，仪器设备集成，大量的一般性环境测验，测量精度、线性度、重复性、互转性、一致性等方面均表现出色。', image: require('../../../image/低温储蓄罐1.png'), to: '/product/hardware/7.html' }
        ]
      },
      {
        name: '无线传感数据传输',
        image: require('../../../image/icon无线传感-蓝.png'),
        selectimage: require('../../../image/icon无线传感-圆.png'),
        children: [
          // { title: '高温温湿度变送器', text: '高温温湿度变送器采用瑞士电容式湿度传感器，生产时已经过精细的标定，标定数据存储在内部存储器中，安全可靠。', image: require('../../../image/t1.png') },
          // { title: '智能井盖解决方案', text: '广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、洁净车间等需测量空气温度的领域。', image: require('../../../image/t2.png') },
          // { title: '数显温湿度变送器', text: '适用于环境设备配套，仪器设备集成，大量的一般性环境测验，测量精度、线性度、重复性、互转性、一致性等方面均表现出色。', image: require('../../../image/t3.png') }
        ]
      }
    ],
    select: 0,
    children: []
  }
  componentWillMount() {
    const { items, select } = this.state
    this.setState({ children: items[select].children })
  }
  selectFn = (index) => {
    const { items } = this.state
    this.setState({ select: index, children: items[index].children })
  }

  render() {
    const { items, select, children } = this.state

    return (
      <div className="typeArea Hardware">
        {this.props.titleIshow && (
          <div className="Hardware-title">
            <div className="Hardware-title-h1">硬件产品</div>
            <div className="Hardware-title-text">HARDWARE PRODUCTS</div>
          </div>
        )}

        <div className="Hardware-content">
          <div className="Hardware-s-content-top">
            {items.map((item, index) => (
              <div key={index} className={`Hardware-seletItem ${select == index ? 'borderbottom' : ''}`} onMouseEnter={() => item.children.length && this.selectFn(index)}>
                {index == select ? (
                  <img className="Hardware-seletItem-img select-box" src={item.selectimage} alt="" />
                ) : (
                  <div className="select-box">
                    <img className="Hardware-seletItem-img" src={item.image} alt="" style={{ width: `${item.name == '环境监测传感器' ? '1.428571rem ' : ' 1.714286rem'}` }} />
                  </div>
                )}
                <div className="Hardware-seletItem-text" style={{ color: `${select == index ? '#2176D0' : '#333333'}` }}>
                  {item.name}
                </div>
              </div>
            ))}
          </div>
          <div className="content">
            {children.map((item, index) => (
              <div className={`content-item ${item.title.length > 0 ? 'hover' : ''}`} key={index}>
                {item.title.length > 0 ? (
                  <div className="content-item-imagebox">
                    <img src={item.image} className="content-item-img" alt="" style={{ width: `${item.title == '气体运行监测报警器' ? '11rem' : ''}`, height: `${item.title == '气体运行监测报警器' ? '7.5rem' : ' 9.571429rem '}` }} />
                  </div>
                ) : (
                  ''
                )}
                {item.title.length > 0 && (
                  <div className="content-item-details ">
                    <div className="content-item-details-texttitle">{item.title}</div>
                    <div className="content-item-details-textcontent">{item.text}</div>
                    <Link to={item.to}>
                      <div className="content-item-details-button">
                        了解更多 <ArrowRightOutlined style={{ fontSize: '.457143rem', marginLeft: '.285714rem ' }} />
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default index
